import { AriaButtonProps } from "react-aria";

import { _Button, ButtonProps } from "./_Button";

interface Variants {
  variant?: "success" | "info" | "danger" | "warning";
}

type Props = Variants &
  AriaButtonProps &
  Pick<
    ButtonProps,
    | "leftIcon"
    | "size"
    | "fullWidth"
    | "isLoading"
    | "testID"
    | "rightIcon"
    | "iconFillOverride"
  >;

export function PrimaryButton(props: Props) {
  const {
    variant = "success",
    testID = "primary-button",
    ...buttonProps
  } = props;

  return (
    <_Button
      color="text-inverse"
      fill={`background-${variant}-strong`}
      focusStyle="focus-action"
      hoverFill={`background-${variant}-strong-hover`}
      shadow="shadow-button"
      testID={testID}
      {...buttonProps}
    />
  );
}
